import { render, staticRenderFns } from "./MyDownloadsFilterTabs.vue?vue&type=template&id=1b698afd&scoped=true"
import script from "./MyDownloadsFilterTabs.vue?vue&type=script&lang=js"
export * from "./MyDownloadsFilterTabs.vue?vue&type=script&lang=js"
import style0 from "./MyDownloadsFilterTabs.vue?vue&type=style&index=0&id=1b698afd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b698afd",
  null
  
)

export default component.exports